const STAFF_ACCESS_ROLES = new Set(["teacher", "staff", "admin"]);

function schoolRoleFor(user, schoolId) {
  return user?.schoolRoles?.[schoolId] || {};
}

/**
 * Membership must come from a server-managed assignment or school-scoped role.
 * The active `schoolId` is a selected context, not proof of membership.
 * @param {object} user Persisted user profile.
 * @param {string} schoolId Target school identifier.
 * @return {boolean} Whether the profile has authoritative membership.
 */
function hasAuthoritativeSchoolMembership(user, schoolId) {
  if (!user || !schoolId) return false;
  if (user.dev === true) return true;
  if (user.assignedSchoolId === schoolId) return true;

  const role = schoolRoleFor(user, schoolId);
  return role.staff === true ||
    role.admin === true ||
    STAFF_ACCESS_ROLES.has(role.accessRole);
}

function hasAuthoritativeSchoolStaffAccess(user, schoolId) {
  if (!hasAuthoritativeSchoolMembership(user, schoolId)) return false;
  if (user.dev === true) return true;

  const role = schoolRoleFor(user, schoolId);
  const scopedStaff = role.staff === true ||
    role.admin === true ||
    STAFF_ACCESS_ROLES.has(role.accessRole);
  const legacyPrimaryStaff = user.assignedSchoolId === schoolId &&
    (user.staff === true || user.admin === true);
  return scopedStaff || legacyPrimaryStaff;
}

function hasAuthoritativeSchoolAdminAccess(user, schoolId) {
  if (!hasAuthoritativeSchoolMembership(user, schoolId)) return false;
  if (user.dev === true) return true;

  const role = schoolRoleFor(user, schoolId);
  const scopedAdmin = role.admin === true || role.accessRole === "admin";
  const legacyPrimaryAdmin = user.assignedSchoolId === schoolId &&
    user.admin === true;
  return scopedAdmin || legacyPrimaryAdmin;
}

export {
  STAFF_ACCESS_ROLES,
  hasAuthoritativeSchoolAdminAccess,
  hasAuthoritativeSchoolMembership,
  hasAuthoritativeSchoolStaffAccess,
  schoolRoleFor,
};
